import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";


import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';

import {getParam} from '../utils/utils';
import {formatText, truncate} from '../utils/utils';

import Buffering from "../components/Buffering"; 

import dsd from "../classes/clsDSD";

import { getLogicalModel, getRelationship, addRelationship, editRelationship, listEntityLinks } from "../utils/utilsLogicalModel";

import D3Graphviz from "../components/D3Graphviz";
import ViewRelationship from "../components/ViewRelationship";
import ViewLogicalModel from "../components/ViewLogicalModel";
import ViewMetadata from "../components/ViewMetadata";

import Revision from "../components/Revision";
import ListRevisions from "../components/ListRevisions";

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

class Relationship extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null
        };


        this.data = {};
        this.viz = null;
        this.vizEngine = "dot";


        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.handleVizClick = this.handleVizClick.bind(this);

        this.refRevision = React.createRef();
        this.loadedRevisions = this.loadedRevisions.bind(this);


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/`;

    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props, prevProps)){
            this.setup();
        }

    }
    
    loadLogicalModel(id){

        this.setState({
            renderState: "loading"
        });

        const onLoad = (LogicalModel) => {
            let StateChange = {
                renderState: "loaded",
                LogicalModel: LogicalModel,
            };

            // Only set default FormData for 'new' mode
            if (this.state.mode === 'new'){
                StateChange.FormData = {status: 'in use'};
            }

            // Check permission for edit
            StateChange.OfferEdit = false;
            if (this.dsd.loggedon){
                if (this.dsd.user.id == LogicalModel.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            // Check if editing is allowed for this mode
            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Relationships to this Logical Model";
                        break;
                }
            }

            this.setState(StateChange);

            // Load entity links for the logical model
            this.loadEntityLinks(id);
        };

        const onFail = (error) => {
            this.setState({
                renderState: error.status || "failed",
                errorMessage: error.errorMessage
            });
        };

        getLogicalModel(this.dsd, id, onLoad, onFail);
        
    };

    loadEntityLinks(idLogicalModel){

        if (idLogicalModel){
            const onLoadEntityLinks = (EntityLinks) => {
                this.setState({
                    EntityLinks: EntityLinks,
                    isLoadedEntityLinks: true
                });
            };

            const onFailEntityLinks = (error) => {
                console.error('Failed to load entity links:', error);
                this.setState({
                    isLoadedEntityLinks: false
                });
            };

            listEntityLinks(this.dsd, {idLogicalModel:idLogicalModel}, onLoadEntityLinks, onFailEntityLinks);
        }
        
    };


    loadRelationship(id){

        this.setState({
            renderState: "loading"
        });

        const onLoad = (Relationship) => {
            let StateChange = {
                renderState: "loaded",
                Relationship: Relationship,
                LogicalModel: Relationship.LogicalModel,
                FormData: Relationship
            };

            if (Relationship.LogicalModel){
                if (this.context.hasLayout){
                    this.context.Layout.setLeftAsLogicalModel(Relationship.LogicalModel._id);
                }
            }

            // Check permission for edit
            StateChange.OfferEdit = false;
            if (Relationship.LogicalModel){
                if (this.dsd.loggedon){
                    if (this.dsd.user.id == Relationship.LogicalModel.idUser){
                        StateChange.OfferEdit = true;
                    }
                }
            }

            // Check if editing is allowed for this mode
            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case "new":
                    case "edit":
                    case "remove":
                        StateChange.renderState = "denied";
                        StateChange.errorMessage = "You cannot add or edit Relationships to this Logical Model";
                        break;
                }
            }

            this.setState(StateChange);

            // Load entity links for the logical model (only needed in new/edit mode)
            if (Relationship.LogicalModel){
                this.loadEntityLinks(Relationship.LogicalModel._id);
            }
        };

        const onFail = (error) => {
            this.setState({
                renderState: error.status || "failed",
                errorMessage: error.errorMessage
            });
        };

        getRelationship(this.dsd, id, onLoad, onFail);
        
    };



    setup(){

        let StateChange = {

            mode: "view",

            idRelationship: null,
            idLogicalModel: null,

            LogicalModel: null,
            Relationship: null,
            EntityLinks: null,

            isUpdated: false,
            isFailed: false,
            isError: false,
            errorMessage: null,

            renderState: null,

            FormData: {
                status:'in use'
            },

            OfferEdit:false,

            Controls: {
            },

            countRevisions: null

        }

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }
        StateChange.idRelationship = getParam('id', this.props);
        StateChange.idLogicalModel = getParam('idLogicalModel', this.props);

        switch (StateChange.mode){
            case 'new':
                if (!StateChange.idLogicalModel){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Logical Model not specified when adding a Relationship"
                }
                break;
            default:
                if (StateChange.idLogicalModel){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Logical Model should not be specified for an existing Relationship"
                }
                if (!StateChange.idRelationship){
                    StateChange.renderState = "invalid";
                    StateChange.errorMessage = "Relationship not be specified for an existing Relationship"
                }
                break;
        }

        if (StateChange.mode == "new"){
            if (StateChange.idLogicalModel){
                this.FallBackNavigation = `/logicalmodel/${StateChange.idLogicalModel}`;
            }        
        }

        if (StateChange.mode == null){
            StateChange.mode = 'view';
        }

        this.setState(StateChange);

        // Load data based on mode
        if (StateChange.idLogicalModel && StateChange.mode === 'new'){
            this.loadLogicalModel(StateChange.idLogicalModel);
        }

        if (StateChange.idRelationship){
            this.loadRelationship(StateChange.idRelationship);
        }
        
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        switch (FormFieldName){
            default:
                let FormData = this.state.FormData;
                FormData[FormFieldName] = FormFieldValue;

                switch (FormFieldName){
                    case 'idEntityFrom':
                    case 'idLink':
                    case 'idEntityTo':

                        let Inverse = false;
 
                        if (this.state.FormData.idEntityFrom && this.state.FormData.idLink){
                            if (this.state.FormData.idEntityTo ){
                                for (let EntityLink of this.state.EntityLinks){
                                    if (EntityLink.Link._id == this.state.FormData.idLink){
                                        if (this.state.FormData.idEntityFrom != this.state.FormData.idEntityTo){
                                            if (EntityLink.EntityFrom && EntityLink.EntityFrom._id == this.state.FormData.idEntityTo){
                                                if (EntityLink.EntityTo && EntityLink.EntityTo._id == this.state.FormData.idEntityFrom){
                                                    Inverse = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else{

                                let AnyNonInverse = false;
                                let AnyInverse = false;

                                for (let EntityLink of this.state.EntityLinks){
                                    if (EntityLink.Link._id == this.state.FormData.idLink){
                                        if (EntityLink.EntityFrom._id == this.state.FormData.idEntityFrom ){
                                            AnyNonInverse = true;
                                        }else
                                        {
                                            AnyInverse = true;
                                        }
                                    }
                                }

                                if (!AnyNonInverse && AnyInverse){
                                    Inverse = true;
                                }
                            }

                        }

                        FormData['inverse'] = Inverse;

            
                }

                this.setState({"FormData": FormData});
                break;                
        }





        return;

    };
    
    handleSubmit(event) {

        window.scrollTo(0, 0);

        switch (event.target.name){
            
            case 'btnCancel':
                
                switch (this.state.mode){
                    case "edit":
                        this.props.navigation(`/relationship/${this.state.idRelationship}`);
                        break;
                    case "new":
                        this.props.navigation(this.FallBackNavigation);
                        break;
                }

                break;
            case 'btnSave':
            default:

                this.setState({
                    isUpdated: false,
                    isFailed: false,
                    renderState: "updating"
                })

                const onAdd = (idRelationship) => {
                    this.props.navigation(`/relationship/${idRelationship}`);
                };

                const onUpdate = () => {
                    this.refRevision.current.update();
                    this.props.navigation(`/relationship/${this.state.idRelationship}`);
                };

                const onError = (error) => {
                    this.setState({
                        renderState: error.status || "error",
                        errorMessage: error.errorMessage,
                        isError: true
                    });
                };
        
                switch (this.state.mode){
                    case 'new':
                        addRelationship(this.dsd, this.state.idLogicalModel, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        editRelationship(this.dsd, this.state.LogicalModel._id, this.state.idRelationship, this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break; 
                };
    
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }


    handleButton(event) {

        let StateChange = {};

        switch (event.target.name){
        }

        this.setState(StateChange);

        event.preventDefault();
    };




    handleVizClick(event) {

        let StateChange = {};

        let idNode = null;
        if ("href" in event.target){
            idNode = event.target.href.baseVal;
        }
        else{
            if ("parentElement" in event.target){
                if ("href" in event.target.parentElement){
                    idNode = event.target.parentElement.href.baseVal;
                }        
            }
        }
        

        StateChange.vizNodeId = idNode;

        this.setState(StateChange);

        event.preventDefault();

    };

    loadedRevisions(count) {

        let StateChange = {};

        StateChange.countRevisions = 0;
        if (count){
            StateChange.countRevisions = count;
        }

        this.setState(StateChange);


    };


    visualise(){
    
        if (!this.state.Relationship){
            return null;
        }



        try {

            return(
                <div>
                    <div name="divViz" onClick={this.handleVizClick}>
                        <D3Graphviz dot={this.viz.dot}/>
                    </div>

                </div>
            );
          } catch (error) {
            return <div/>
          }
    };


    render() {

        switch (this.state.renderState){
            case "invalid":
            case "failed":
            case "denied":
                let Message = "An error has occured";
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>
                break;
            case "loading":
                return <Buffering/>
                break;
            case "cancelled":
                return <p>Cancelled</p>
                break;
    
        }

        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case "loaded":
                    case "updating":
                    case "error":

                        let disabledEntityFrom = false;
                        let disabledLink = true;
                        let disabledInverse = true;
                        let disabledEntityTo = true;
                        let labelLink = "";
                        let disabledCardinality = true;


                        let FromEntities = {};
                        let Links = {};
                        let ToEntities = {};


                        if (this.state.EntityLinks){
                            for (let EntityLink of this.state.EntityLinks){
                                if (EntityLink.EntityFrom){
                                    FromEntities[EntityLink.EntityFrom._id] = EntityLink.EntityFrom;
                                }
                                if (EntityLink.EntityTo){
                                    FromEntities[EntityLink.EntityTo._id] = EntityLink.EntityTo;
                                }
                            }

                            if (this.state.FormData.idEntityFrom){
                                disabledLink = false;
                                for (let EntityLink of this.state.EntityLinks){
                                    if (EntityLink.Link){
                                        if (EntityLink.EntityFrom._id == this.state.FormData.idEntityFrom){
                                            Links[EntityLink.Link._id] = EntityLink.Link;
                                        }
                                        if (EntityLink.EntityTo._id == this.state.FormData.idEntityFrom){
                                            Links[EntityLink.Link._id] = EntityLink.Link;
                                        }
                                    }
                                }

                                if (this.state.FormData.idLink){
                                    disabledEntityTo = false;
                                    for (let EntityLink of this.state.EntityLinks){
                                        if (EntityLink.Link._id == this.state.FormData.idLink){
                                            if (EntityLink.EntityFrom){
                                                if (EntityLink.EntityFrom._id == this.state.FormData.idEntityFrom){
                                                    ToEntities[EntityLink.EntityTo._id] = EntityLink.EntityTo;
                                                }
                                            }
                                            if (EntityLink.EntityTo){
                                                if (EntityLink.EntityTo._id == this.state.FormData.idEntityFrom){
                                                    ToEntities[EntityLink.EntityFrom._id] = EntityLink.EntityFrom;
                                                }
                                            }

                                        }
                                    }

                                    if (this.state.FormData.idEntityTo){
                                        disabledCardinality = false;
                                    }


                                }


                            }
                        }

                        if (this.state.FormData.idLink){
                            if (this.state.FormData.idLink in Links){
                                const Link = Links[this.state.FormData.idLink];
                                if (Link.ConceptFrom && Link.ConceptTo){
                                    labelLink = `${Link.ConceptFrom.name} ${Link.label} ${Link.ConceptTo.name}`;
                                    if (this.state.FormData.inverse){
                                        labelLink = `${Link.ConceptTo.name} ${Link.inverseLabel} ${Link.ConceptFrom.name}`;
                                    }
                                }
                            }
                        }



                        return (
                            <div>

                                <PD.Heading>{this.state.mode} Relationship</PD.Heading>

                                {this.state.renderState == "error" &&
                                    <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                                }

                                <form> 

                                    {this.state.EntityLinks &&
                                        <>
                                            <PD.Select disabled={disabledEntityFrom} label="From Entity" name="idEntityFrom" onChange={this.handleChange} value={this.state.FormData.idEntityFrom}>
                                                {
                                                    Object.keys(FromEntities).map(
                                                        (idEntity, pos) => 
                                                            {
                                                                let Entity = FromEntities[idEntity];
                                                                return(
                                                                    <option key={pos} value={Entity._id}>
                                                                        {Entity.name}
                                                                        {(Entity.status == 'deprecated') &&
                                                                            <span> (deprecated)</span>
                                                                        }
                                                                    </option>
                                                                )
                                                            }
                                                    )
                                                }
                                            </PD.Select>

                                            <PD.Select disabled={disabledLink} label="Link" name="idLink" onChange={this.handleChange} value={this.state.FormData.idLink}>
                                                {
                                                    Object.keys(Links).map(
                                                        (idLink, pos) => 
                                                            {
                                                                let Link = Links[idLink];
                                                                return(
                                                                    <option key={pos} value={Link._id}>
                                                                        {Link.name}
                                                                        {(Link.status == 'deprecated') &&
                                                                            <span> (deprecated)</span>
                                                                        }
                                                                    </option>
                                                                )
                                                            }
                                                    )

                                                }
                                            </PD.Select>

                                            {this.state.FormData.inverse &&
                                                <div className="field-row">
                                                    <label  className="field-legend"></label>
                                                    (inverse)
                                                </div>                                       
                                            }

                                            <div className="field-row">
                                                <label  className="field-legend">Link Label</label>
                                                {labelLink}
                                            </div>

                                            <PD.Select  disabled={disabledEntityTo} label="To Entity" name="idEntityTo" onChange={this.handleChange} value={this.state.FormData.idEntityTo}>
                                                {
                                                    Object.keys(ToEntities).map(
                                                        (idEntity, pos) => 
                                                            {
                                                                let Entity = ToEntities[idEntity];
                                                                return(
                                                                    <option key={pos} value={Entity._id}>
                                                                        {Entity.name}
                                                                        {(Entity.status == 'deprecated') &&
                                                                            <span> (deprecated)</span>
                                                                        }
                                                                    </option>
                                                                )
                                                            }
                                                    )

                                                }
                                            </PD.Select>

                                        </> 
                                    }

                                    <PD.Select disabled={disabledCardinality} label="Cardinality" name='cardinality'  onChange={this.handleChange} value={this.state.FormData.cardinality}>
                                        {
                                            this.dsd.config.RelationshipCardinalities.map(
                                                (cardinality, posCardinality) => 
                                                    {
                                                        return(
                                                            <option key={posCardinality} value={cardinality}>{cardinality}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>

                                    <PD.Editor name="description" label='Description' value={this.state.FormData.description} onChange={this.handleChange}/>
                                    <PD.Editor name="proposals" label='Proposals' value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    <PD.Select label="Status" name='status'  onChange={this.handleChange} value={this.state.FormData.status}>
                                        {
                                            this.dsd.config.RelationshipStatuses.map(
                                                (status, posStatus) => 
                                                    {
                                                        return(
                                                            <option key={posStatus} value={status}>{status}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>

                                    <Revision ref={this.refRevision}  idAbout={this.state.idRelationship}/>

                                    
                                    {(() => {
                                        switch (this.state.renderState) {
                                            case "updating":
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />    
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" /> 
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>

                            </div>    
                        );
                }
                break;
            case 'remove':
                return (
                    <div>
                        <PD.Heading>{this.state.mode} Relationship</PD.Heading>

                        {this.state.isFailed &&
                            <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                        }

                        <PD.Button onClick={this.handleSubmit} type="warning" value="confirm remove?" />
                        <ViewRelationship Relationship={this.state.Relationship}/>
                    </div>
                )
            case 'view':
            default:
                
                switch (this.state.renderState){
                    case "loaded":
                        return (
                            <div>
                                <div>
                                    <PD.Breadcrumb crumbs={this.Breadcrumb}/>
                                    <PD.Heading>Relationship:{this.state.Relationship.name}</PD.Heading>
                                </div>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                            <PD.Button onClick={this.handleMode} type="submit" value="edit" />                        
                                    </span>
                                }

                                <ViewRelationship Relationship={this.state.Relationship}/>

                                <br/>

                                <PD.Tabs>


                                    <div label='Logical Model'>
                                        <ViewLogicalModel LogicalModel={this.state.LogicalModel} />
                                    </div>

                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.Relationship} />
                                    </div>

                                    <div label={<span>Revisions({this.state.countRevisions === null ? <Buffering/> : this.state.countRevisions})</span>} data-forcerender="true">
                                        <ListRevisions OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idRelationship}} onLoad={this.loadedRevisions}/>
                                    </div>


                                </PD.Tabs>


                            </div>
                        )
                }
        };

        return <div />;
    };


};

// Wrap and export
export default function Relationship_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Relationship {...props} navigation={navigation} location={location} params={params} />;
  }
